import { FC } from 'react';
import { observer } from 'mobx-react';
import AppLayout from "modules/contacts/containers/Single/components/Layout";
import contactStore from 'stores/contact';
import Files from 'submodules/files/containers/index';


const ContactFiles: FC = observer(() => {
  const contact: any = contactStore.selected;

  return (
    <AppLayout>
      <Files resource_type='Contact' resource={contact} />
    </AppLayout>
  );
})

export default ContactFiles;
